import { AppBar, CircularProgress, Tab, Tabs, makeStyles } from "@material-ui/core"
import { GetUrlDetails, POWERBI_CASL_PREFIX, TabPanel, defaultVariable, keyCloakConfig, urlReplace } from "common"
import PowerBiReport from "components/powerBiReport";
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { getAccessPermissions } from "services/powerBiService";

function a11yProps(index: any) {
  return {
    id: `scrollable-force-tab-${index}`,
    "aria-controls": `scrollable-force-tabpanel-${index}`,
  };
}
const useStyles = makeStyles((theme) => ({
  toolbar: theme.mixins.toolbar,
  content: {
    flex: 'grow',
    border: '0px solid blue'
  },
}));

const getUserRole = (access: any) => {
  if (access) {
      const ret =  defaultVariable?.allowedAccessRoles.filter((value: any) => access?.roles?.includes(value))?.toString();
      return ret;
  }
};

const PowerBiTabsWrapper = (props: any) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const history = useHistory();
  const tab = parseInt(history.location.hash.slice(1));
  //@ts-ignore
  const {claims, filterValues, received} = useSelector((state) => state?.sidebarItems?.userReportsEnabled);
  console.log(`claims: `, claims, ` filterValues: `, filterValues, ` received: ${received}`);
  const userInfo = keyCloakConfig?.tokenParsed;
  const userRole = getUserRole(userInfo?.realm_access);
  const [reportsAccess, setReportsAccess] = useState<any>([]);
  const [returnedAccessPermissions, setReturnedAccessPermissions] = useState({
    claims: new Set(claims),
    filterValues: filterValues,
    received: false
  })
  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);

    let { pathname } = GetUrlDetails(history, 'userGroupDetail');
    history.push({
        pathname: pathname,
        hash: '#' + newValue,
        search: history.location.search,
    });

};

  const listenToScroll = () => {
    let heightToHideFrom = 50;
    const winScroll = document.body.scrollTop ||
      document.documentElement.scrollTop;
    if (winScroll > heightToHideFrom) {
      isVisible &&      // to limit setting state only the first time         
        setIsVisible(false);
    } else {
      setIsVisible(true);
    }
  };

  const toSortedNames = (arr: any[]) => arr.slice().sort((a: string, b: string) => a.localeCompare(b));
  const toSortedKeys = (arr: any[]) => {
    const keyArr: string[] = arr.map(val => defaultVariable.powerBiReportKeywordRevMap[val]);
    return keyArr.slice().sort((a: string, b: string) => a.localeCompare(b));
  }

useEffect(() => {
  window.addEventListener("scroll", listenToScroll);
  const fetchPermissions = async () => {
    await getAccessPermissions()
    .then((res) => {
      if (res) {
          // @ts-ignore
          setReturnedAccessPermissions(res);
      }
  })
  }
  fetchPermissions();
  return () =>
    window.removeEventListener("scroll", listenToScroll);
}, [])

useEffect(()=>{
  setValue(tab < Array.from(returnedAccessPermissions?.claims)?.length ? tab : 0)
},[tab])

  return (
    <>
      {/*----Page Mid Section Start----*/}
      <main className={classes.content} data-testid="user_group_detail">
        <div className={isVisible ? "" : "scroll_effect"}>
          <div className="depot_details host_settings powerbi_wrapper">
            <div className="detail_page_tab">
              {returnedAccessPermissions?.received === false ?
                  <CircularProgress className="inner_progress" />
                  :
                  <>
                  {returnedAccessPermissions?.claims && Array.from(returnedAccessPermissions?.claims)?.length > 0 ? 
                <AppBar
                  className="defult_tab"
                  position="static"
                  color="default"
                >
                  <Tabs
                    className="tab_nav"
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable force tabs example"
                  >
                    {returnedAccessPermissions?.claims && toSortedNames(Array.from(returnedAccessPermissions?.claims)).map((c,idx) => 
                      <Tab
                      key={c}
                      className="tab_nav_item"
                      label={t(c)}
                      {...a11yProps(idx)}
                    />)}
                  </Tabs>
                </AppBar>
                : <p>{t("forbidden.reports")}</p>
              }
              {returnedAccessPermissions?.claims && toSortedKeys(Array.from(returnedAccessPermissions?.claims)).map((c,idx) => 
                {
                  return <TabPanel
                  key={c}
                  className="tab_nav_item"
                  {...props}
                  value={value}
                  index={idx}
                >
                {/** @ts-ignore */}
                <PowerBiReport userRole = {userRole} reportName = {defaultVariable?.powerBiReportKeywordMap[c]?.replace(POWERBI_CASL_PREFIX,'')} filterValues={returnedAccessPermissions?.filterValues[c]}/>
              </TabPanel>})}
              </>
              }
            </div>
          </div>
        </div>
      </main>

      {/*----Page Mid Section End----*/}
    </>)
}

export default PowerBiTabsWrapper;